"use client";
import React from 'react';
import { ReportFilterType } from '../types';
import { NumericFromToFilter } from '@/components';
import { DateRangePicker, FormGroup, Input } from '@develos/next-components';
import { useTranslations } from '@develos/next-library';

type Props = {
  filters: ReportFilterType,
  setFilters: React.Dispatch<React.SetStateAction<ReportFilterType>>,
}

const FromToArgumentsContainer = ({filters, setFilters}: Props) => {
  const { translate } = useTranslations();
  return (
    <>
        <div className="rm-relative md:rm-col-span-6 xl:rm-col-span-3">  
          <FormGroup label={translate('Liczba osi')}>
            <NumericFromToFilter
              value={filters.axelsCounts}
              handleChange={(value) => setFilters({
                ...filters, 
                axelsCounts: value
              })} 
            />
          </FormGroup>
        </div>
        <div className="rm-relative md:rm-col-span-6 xl:rm-col-span-3">  
          <FormGroup label={translate('Prędkość')}>
            <NumericFromToFilter
              value={filters.speed}
              handleChange={(value) => setFilters({
                ...filters, 
                speed: value
              })} 
            />
          </FormGroup>
        </div>
        <div className="rm-relative md:rm-col-span-6 xl:rm-col-span-3">  
          <FormGroup label={translate('Waga')}>
            <NumericFromToFilter
              value={filters.weight}
              handleChange={(value) => setFilters({
                ...filters, 
                weight: value
              })} 
            />
          </FormGroup>
        </div>
        <div className="rm-relative md:rm-col-span-6 xl:rm-col-span-3">  
          <FormGroup label={translate('Tablica rejestracyjna')}>
            <Input.Text
              value={filters.registrationNumber}
              handleChange={(event, value) => setFilters({
                ...filters, 
                registrationNumber: value!
              })} 
            />
          </FormGroup>
        </div>
        <div className="rm-relative md:rm-col-span-6 xl:rm-col-span-3">  
          <FormGroup label={translate('Przedział czasowy')}>
            <DateRangePicker
              value={filters.dates}
              handleChange={(event, dates: any) => setFilters({
                ...filters, 
                dates: dates
              })} 
            />
          </FormGroup>
        </div>
    </>
  );
};

export default FromToArgumentsContainer;